export function thousandsFormatter(value: string | number) {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}

export function clearNumberFormatter(value: string | number): string {
  return value.toString().replace(/ /g, '')
}

export function unitValueFormatter(value: number | string, unit: string) {
  return `${value} ${unit}`
}

export function numberValueFormatter(
  value: number,
  decimals: number = 0,
  blankChar: string = '',
) {
  return value ? value.toFixed(decimals) : blankChar
}
